export const VIP_SETTING = {
  data: {
    tnc: {
      'en-US': '<p>vzdfgzdf</p>'
    },
    landing_bg: {
      desktop: '/demo/vip/bg-ch.png',
      mobile: '/demo/vip/bg-th.png'
    },
    status: 1
  }
}

export const VIP_SYSTEM = {
  data: {
    player: {
      condition_type: 2,
      total_amount: 120000,
      current_tier: {
        name: {
          'en-US': 'Silver'
        },
        id: '795fe82d-1b58-4e8f-ba3e-cc930f4ec5c4',
        file: '/demo/tiers/silver.png'
      }
    },
    tiers: [
      {
        id: 'e75de843-4e80-4bc5-abad-0e732ee8e685',
        name: {
          'th-TH': 'ทุกชั้น',
          'zh-CN': '初始等级',
          'en-US': 'All tiers'
        },
        tier_type: 2,
        file: null,
        min_range: 0,
        max_range: 0,
        level_up_reward: '0',
        birthday_reward: '0',
        level_up_status: 1,
        birthday_status: 1
      },
      {
        id: '35db0469-893d-4266-845f-52a2251480b1',
        name: {
          'en-US': 'Bronze'
        },
        tier_type: 1,
        file: '/demo/tiers/bronze.png',
        min_range: 0,
        max_range: 100000,
        level_up_reward: '100',
        birthday_reward: '200',
        level_up_status: 1,
        birthday_status: 1
      },
      {
        id: '795fe82d-1b58-4e8f-ba3e-cc930f4ec5c4',
        name: {
          'en-US': 'Silver'
        },
        tier_type: 1,
        file: '/demo/tiers/silver.png',
        min_range: 100000,
        max_range: 500000,
        level_up_reward: '300',
        birthday_reward: '600',
        level_up_status: 1,
        birthday_status: 1
      },
      {
        id: '16604f68-5058-4d45-a230-560ad79d88c6',
        name: {
          'en-US': 'Gold'
        },
        tier_type: 1,
        file: '/demo/tiers/gold.png',
        min_range: 500000,
        max_range: 1000000,
        level_up_reward: '1000',
        birthday_reward: '2000',
        level_up_status: 1,
        birthday_status: 1
      },
      {
        id: '4d946c6e-9fb4-4da8-8cfa-d8fc512ec362',
        name: {
          'en-US': 'Diamond'
        },
        tier_type: 1,
        file: '/demo/tiers/diamond.png',
        min_range: 1000000,
        max_range: 5000000,
        level_up_reward: '3000',
        birthday_reward: '6000',
        level_up_status: 1,
        birthday_status: 1
      },
      {
        id: '01ad332f-32f5-44b5-bd41-7b54c895ad51',
        name: {
          'en-US': 'Platinum'
        },
        tier_type: 1,
        file: '/demo/tiers/platinum.png',
        min_range: 5000000,
        max_range: 10000000000,
        level_up_reward: '6000',
        birthday_reward: '12000',
        level_up_status: 1,
        birthday_status: 1
      }
    ]
  }
}
